import { HamletClientContext } from "../contexts/hamlet";

import { useContext } from "react";

import { Cart } from "@atlassiansox/asc-hamlet";

import { AsyncResult, useAsync } from "./use-async";

export function useCart(cartId: string): AsyncResult<Cart> {
    const hamletClient = useContext(HamletClientContext);

    return useAsync(() => hamletClient.getCart({ cartId }), [cartId]);
}
